var _style, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconIntercomSuccess = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 148 142",
    style: {
      enableBackground: "new 0 0 148 142"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#202428;}\n\t.st2{fill:#00B7A0;}\n\t.st3{fill:none;stroke:#F7F7F7;stroke-width:3.1818;stroke-linecap:round;}\n\t.st4{fill:none;stroke:#F7F7F7;stroke-width:3.1895;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 110.9,
    cy: 36.9,
    rx: 35.1,
    ry: 35.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "97.1,40.8 105,48.8 124.6,29.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,86.6H86.8c-1.6,0-2.9,1.3-2.9,2.9v2.1c0,1.6,1.3,2.9,2.9,2.9h14.5c1.6,0,2.9-1.3,2.9-2.9v-2.1 C104.3,87.9,102.9,86.6,101.4,86.6z M102.6,91.6c0,0.7-0.6,1.2-1.2,1.2H86.8c-0.7,0-1.2-0.5-1.2-1.2v-2.1c0-0.7,0.5-1.2,1.2-1.2 h14.5c0.7,0,1.2,0.5,1.2,1.2V91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,96.7H86.8c-1.6,0-2.9,1.3-2.9,2.9v2.1c0,1.6,1.3,2.9,2.9,2.9h14.5c1.6,0,2.9-1.3,2.9-2.9v-2.1 C104.3,98,102.9,96.7,101.4,96.7z M102.6,101.7c0,0.7-0.6,1.2-1.2,1.2H86.8c-0.7,0-1.2-0.6-1.2-1.2v-2.1c0-0.7,0.5-1.2,1.2-1.2 h14.5c0.7,0,1.2,0.6,1.2,1.2V101.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.4,106.8H86.8c-1.6,0-2.9,1.3-2.9,2.9v2.1c0,1.6,1.3,2.9,2.9,2.9h14.5c1.6,0,2.9-1.3,2.9-2.9v-2.1 C104.3,108.1,102.9,106.8,101.4,106.8z M102.6,111.8c0,0.7-0.6,1.2-1.2,1.2H86.8c-0.7,0-1.2-0.6-1.2-1.2v-2.1 c0-0.7,0.5-1.2,1.2-1.2h14.5c0.7,0,1.2,0.5,1.2,1.2V111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.1,63.2H48.4c-2.2,0-4-1.8-4-4V24.1c0-2.2,1.8-4,4-4h23.9c0.2-0.5,0.5-1.1,0.8-1.6H48.4 c-3.1,0-5.7,2.5-5.7,5.7v35.2c0,3.1,2.5,5.6,5.7,5.6h31.1C79,64.3,78.5,63.8,78.1,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.3,115.8c0,2.2-1.8,4-4,4H41.6c-2.2,0-4-1.8-4-4V17.1c0-2.2,1.8-4,4-4h34.6c0.4-0.6,0.8-1.1,1.2-1.7H41.6 c-3.1,0-5.7,2.5-5.7,5.7v98.7c0,3.1,2.5,5.7,5.7,5.7h8.9v1.1c0,8.6-7,15.6-15.6,15.6c-8.6,0-15.6-7-15.6-15.6v-1.1h8.9 c3.1,0,5.7-2.5,5.7-5.7V17.1c0-3.1-2.5-5.7-5.7-5.7H7.6C4.5,11.4,2,14,2,17.1v98.7c0,3.1,2.5,5.7,5.6,5.7h10v1.1 c0,9.5,7.7,17.3,17.3,17.3c9.5,0,17.3-7.7,17.3-17.3v-1.1h53.1c3.1,0,5.6-2.5,5.6-5.7V79c-0.6,0-1.1,0-1.7,0V115.8z M7.6,119.8 c-2.2,0-4-1.8-4-4V17.1c0-2.2,1.8-4,4-4h20.6c2.2,0,4,1.8,4,4v98.7c0,2.2-1.8,4-4,4H7.6z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconIntercomSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_intercom-success.7e3a57d8.svg";
export { ForwardRef as ReactComponent };